/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramWhiteLabelsControllerFindOneByCountryQueryResponse,
  TelegramWhiteLabelsControllerFindOneByCountryPathParams,
  TelegramWhiteLabelsControllerFindOneByCountry404,
} from '../types/TelegramWhiteLabelsControllerFindOneByCountry.ts';

function getTelegramWhiteLabelsFindOneByCountryUrl(
  countryCode: TelegramWhiteLabelsControllerFindOneByCountryPathParams['countryCode'],
) {
  const res = { method: 'GET', url: `/api/telegram/white-labels/country/${countryCode}` as const };
  return res;
}

/**
 * {@link /api/telegram/white-labels/country/:countryCode}
 */
export async function telegramWhiteLabelsFindOneByCountry(
  countryCode: TelegramWhiteLabelsControllerFindOneByCountryPathParams['countryCode'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramWhiteLabelsControllerFindOneByCountryQueryResponse,
    ResponseErrorConfig<TelegramWhiteLabelsControllerFindOneByCountry404>,
    unknown
  >({ method: 'GET', url: getTelegramWhiteLabelsFindOneByCountryUrl(countryCode).url.toString(), ...requestConfig });
  return res.data;
}
